import styled from "styled-components";

import { shimmer } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

export const GroupHorizontalLogoContainer = styled.div`
  img {
    border-radius: 4px;
    width: 100%;

    &[data-is-loading="true"] {
      background: linear-gradient(
        90deg,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 25%,
        ${({ theme }) => (theme.mode === "dark" ? "#424242" : "#CECECE")} 50%,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 75%
      );
      background-size: 200% 100%;

      animation: ${shimmer} 1.5s infinite ease-in-out;
    }

    @media (max-width: 1400px) {
      max-height: 123px;
      width: 100%;
    }
  }
`;
